import {
  AlertProvider,
  ToastProvider,
  TooltipProvider,
} from "@prismicio/editor-ui"

import { BannerProvider } from "./banners/GlobalBanner"
import { AppErrorHandler } from "./components/AppErrorHandler"
import { AppSuspense } from "./components/AppSuspense"
import { AppThemeProvider, QueryProvider } from "./components/providers"
import { AmplitudeExperiments } from "./integrations/AmplitudeExperiments"
import { Intercom } from "./integrations/intercom"
import { AppRouterProvider } from "./routing"

export function App() {
  return (
    <AppThemeProvider>
      <QueryProvider>
        <AppErrorHandler>
          <AppSuspense>
            <AlertProvider>
              <ToastProvider>
                <TooltipProvider>
                  <Intercom>
                    <AmplitudeExperiments>
                      <BannerProvider>
                        <AppRouterProvider />
                      </BannerProvider>
                    </AmplitudeExperiments>
                  </Intercom>
                </TooltipProvider>
              </ToastProvider>
            </AlertProvider>
          </AppSuspense>
        </AppErrorHandler>
      </QueryProvider>
    </AppThemeProvider>
  )
}
